module.exports = __webpack_public_path__ + "pe-icon-set-weather.4d4b315975848c13a7be.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/assets/fonts/pe/fonts/pe-icon-set-weather.eot?nlruav
// module id = ../../../../../src/assets/fonts/pe/fonts/pe-icon-set-weather.eot?nlruav
// module chunks = styles